import styled, { css } from 'styled-components';
import { rem } from '~/src/helpers/rem-converter.helper';
import { COLORS } from '~/src/styles/tokens/colors';
import { Z_INDEX } from '~/src/styles/tokens/z-index';
import { BORDER_RADIUS } from '~/src/styles/tokens/border-radius';

export const BurgerButton = styled.button<{ tapAnimate: boolean; }>`
    padding: ${rem(4)};
    background: transparent;
    border: none;
    position: relative;
    z-index: ${Z_INDEX.level1};
    
    &:focus {
        outline-width: 0;
    }

    &:after {
        content: '';
        position: absolute;
        display: block;
        top: ${rem(-9)};
        left: 50%;
        transform: translateX(-50%);
        width: 170%;
        height: 170%;
        background: ${COLORS.constantGreyscale100};
        z-index: ${Z_INDEX.bottom};
        border-radius: ${BORDER_RADIUS.round};
        opacity: ${p => p.tapAnimate ? 1 : 0};
    }
`;

export const MenuBar = styled.div`
    background: ${COLORS.controlsLightStrokeRadio};
    transition: transform 0.2s, left 0.2s, top 0.2s, right 0.2s, bottom 0.2s, opacity 0.2s;
    border-radius: ${BORDER_RADIUS.big16};
    height: ${rem(2)};
    position: absolute;
    width: ${rem(18)};
`;

export const MenuTopBar = styled(MenuBar)`
    top: ${rem(2)};
`;

export const MenuMiddleBar = styled(MenuBar)`
    top: ${rem(8)};
`;

export const MenuBottomBar = styled(MenuBar)`
    top: ${rem(14)};
`;

export const BarsContainer = styled.div<{ isOpen: boolean; }>`
    position: relative;
    width: ${rem(18)};
    height: ${rem(18)};
    
    ${MenuTopBar} {
        ${p => p.isOpen && css`transform: rotate(-45deg) translate(${rem(-4.5)}, ${rem(4.5)});`};
    }

    ${MenuMiddleBar} {
        ${p => p.isOpen && css`transform: rotate(45deg);`};    
    }

    ${MenuBottomBar} {
        ${p => p.isOpen && css`transform:  rotate(-45deg)  translate(${rem(3.5)}, ${rem(-3.5)});`};
        opacity: ${p => p.isOpen ? 0 : 1};
    }
`;
